import { StateCreator } from 'zustand'
import { TelegramPostType } from '@/shared/types'
import { CampaignCreationState } from '../state'

export interface Step1Slice {
    telegramPosts: TelegramPostType[]
    selectedTelegramPosts: TelegramPostType[]
    setTelegramPosts: (posts: TelegramPostType[]) => void
    setSelectedTelegramPosts: (posts: TelegramPostType[]) => void
}

export const createStep1Slice: StateCreator<
    CampaignCreationState,
    [],
    [],
    Step1Slice
> = (set) => ({
    telegramPosts: [],
    selectedTelegramPosts: [],
    setTelegramPosts: (posts) => set({ telegramPosts: posts }),
    setSelectedTelegramPosts: (posts) => set({ selectedTelegramPosts: posts }),
})
